/* eslint-disable @typescript-eslint/no-unused-vars */
document.addEventListener('DOMContentLoaded', (t) => {
  Q.init()
})
const Q = (function () {
  let t = {
      welcome:
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_Intro_1024x1024.gif?v=18407380632787541785',
      '6658336695f1923cc3661243':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_HairType_800x1600_5c833209-3a57-4baf-9140-734f1621d770_1024x1024.jpg?v=6907250637364049497',
      '6658336695f1923cc3661248':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_HairText_800x1600_476ab305-54ec-4ade-8354-6ecb38baa9f8_1024x1024.jpg?v=8360269813069369998',
      '6658336695f1923cc366124d':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_SalonLife_800x1600_32f5f3af-572f-42ff-9e84-6d81e7c98d8b_1024x1024.jpg?v=12452088579627742241',
      '6658336695f1923cc3661252':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_HeatTools_800x1600_a4fb4aaf-107b-4d6a-948e-4d3733cfedac_1024x1024.jpg?v=604014172182939219',
      '6658336695f1923cc3661255':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_MainConcern_800x1600_0c08a420-0578-47c3-a8e9-cb7ff0b312d5_1024x1024.jpg?v=8288228023811225152',
      '6658336695f1923cc3661260':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_Time_800x1600_05cb6a9f-2c85-410e-a308-8573064e3fb0_1024x1024.jpg?v=10977865972986133878',
      '665870f395f1923cc36664a7':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_Name_800x1600_cfbb1a67-a4ba-43db-a99c-c22508b92980_1024x1024.jpg?v=15033206330795628675',
      '66585e5c95f1923cc3664898':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_HairType_800x1600_5c833209-3a57-4baf-9140-734f1621d770_1024x1024.jpg?v=6907250637364049497',
      '66585e5c95f1923cc366489d':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_HairText_800x1600_476ab305-54ec-4ade-8354-6ecb38baa9f8_1024x1024.jpg?v=8360269813069369998',
      '66585e5c95f1923cc36648a2':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_SalonLife_800x1600_32f5f3af-572f-42ff-9e84-6d81e7c98d8b_1024x1024.jpg?v=12452088579627742241',
      '66585e5c95f1923cc36648a7':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_HeatTools_800x1600_a4fb4aaf-107b-4d6a-948e-4d3733cfedac_1024x1024.jpg?v=604014172182939219',
      '66585e5c95f1923cc36648aa':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_MainConcern_800x1600_0c08a420-0578-47c3-a8e9-cb7ff0b312d5_1024x1024.jpg?v=8288228023811225152',
      '66585e5c95f1923cc36648b5':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_Time_800x1600_05cb6a9f-2c85-410e-a308-8573064e3fb0_1024x1024.jpg?v=10977865972986133878',
      '66d975dcf79caa7a5948a08b':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_HairType_800x1600_5c833209-3a57-4baf-9140-734f1621d770_1024x1024.jpg?v=6907250637364049497',
      '66d975dcf79caa7a5948a090':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_HairText_800x1600_476ab305-54ec-4ade-8354-6ecb38baa9f8_1024x1024.jpg?v=8360269813069369998',
      '66d975dcf79caa7a5948a095':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_SalonLife_800x1600_32f5f3af-572f-42ff-9e84-6d81e7c98d8b_1024x1024.jpg?v=12452088579627742241',
      '66d975dcf79caa7a5948a09a':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_HeatTools_800x1600_a4fb4aaf-107b-4d6a-948e-4d3733cfedac_1024x1024.jpg?v=604014172182939219',
      '66d975dcf79caa7a5948a09d':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_MainConcern_800x1600_0c08a420-0578-47c3-a8e9-cb7ff0b312d5_1024x1024.jpg?v=8288228023811225152',
      '66d975dcf79caa7a5948a0a8':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_Time_800x1600_05cb6a9f-2c85-410e-a308-8573064e3fb0_1024x1024.jpg?v=10977865972986133878',
      '66d975dcf79caa7a5948a0ac':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_Name_800x1600_cfbb1a67-a4ba-43db-a99c-c22508b92980_1024x1024.jpg?v=15033206330795628675',
      '66e0329df79caa7a594c97cd':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_HairType_800x1600_5c833209-3a57-4baf-9140-734f1621d770_1024x1024.jpg?v=6907250637364049497',
      '66e0329df79caa7a594c97d2':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_HairText_800x1600_476ab305-54ec-4ade-8354-6ecb38baa9f8_1024x1024.jpg?v=8360269813069369998',
      '66e0329df79caa7a594c97d7':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_SalonLife_800x1600_32f5f3af-572f-42ff-9e84-6d81e7c98d8b_1024x1024.jpg?v=12452088579627742241',
      '66e0329df79caa7a594c97dc':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_HeatTools_800x1600_a4fb4aaf-107b-4d6a-948e-4d3733cfedac_1024x1024.jpg?v=604014172182939219',
      '66e0329df79caa7a594c97df':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_MainConcern_800x1600_0c08a420-0578-47c3-a8e9-cb7ff0b312d5_1024x1024.jpg?v=8288228023811225152',
      '66e0329df79caa7a594c97ea':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_Time_800x1600_05cb6a9f-2c85-410e-a308-8573064e3fb0_1024x1024.jpg?v=10977865972986133878',
      '66e0329df79caa7a594c97ee':
        '//olaplex.com/cdn/shop/files/5456_HairQuiz_Lifestyle_Name_800x1600_cfbb1a67-a4ba-43db-a99c-c22508b92980_1024x1024.jpg?v=15033206330795628675',
    },
    c = null,
    i = null,
    l = null,
    n = null,
    s = null,
    r = !1,
    m = () => {
      ;(c = document.getElementById('tangent-block-quiz-iframe')),
        (i = document.getElementById('side-img')),
        (l = document.getElementById('cover_img_container')),
        (n = document.getElementById('tangent-page-loader'))
      let e = document.getElementById('tangent-shop-id').value,
        a = document.getElementById('tangent-shop-market').value
      o(n),
        f(i),
        (s = z() && screen.width < 800),
        c.addEventListener('load', function () {
          p()
        })
      let _ = null
      ;(_ =
        a == 'gb'
          ? '66d975dcf79caa7a5948a064'
          : a == 'au'
            ? '66e0329df79caa7a594c97a6'
            : '6658336695f1923cc366121c'),
        (c.src = `https://a.tangent.ai/quiz-app/1.0.99/en/?shop_id=4341661&form_id=${_}`),
        g(),
        window.addEventListener('message', (d) => {
          c.src.startsWith(d.origin) && (p(), b(d))
        })
    },
    x = (e) => {
      let a = setInterval(() => {
        window.Shopify &&
          window.Shopify.customerPrivacy != null &&
          (clearInterval(a), e())
      }, 500)
      setTimeout(() => {
        clearInterval(a)
      }, 1e4)
    },
    g = () => {
      x(() => {
        window.Shopify.customerPrivacy.analyticsProcessingAllowed() ||
          c.contentWindow.postMessage('tangent_tracking:optout', c.src)
      })
    },
    p = () => {
      r || (o(c), v(c), (r = !0))
    },
    b = (e) => {
      if (!H(e.data)) return
      let a = JSON.parse(e.data)
      a.quiz_type == 'inline' &&
        (a.key == 'iframe-height' && L(a.value),
        a.key == 'screenId' &&
          (t[a.screen_id] != null &&
            i.src != t[a.screen_id] &&
            (i.setAttribute('src', ''),
            i.setAttribute('src', t[a.screen_id]),
            f(n),
            o(i)),
          a.screen_id == 'welcome'
            ? u()
            : a.screen_id == 'summary'
              ? y()
              : h()))
    },
    u = () => {
      s &&
        (c.classList.remove('tangent-mobile-iframe-default'),
        c.classList.add('tangent-mobile-iframe-welcome')),
        o(l),
        i.classList.remove('tangent-side-img-width-default'),
        i.classList.add('tangent-side-img-width-welcome')
    },
    h = () => {
      s
        ? (f(l),
          c.classList.remove('tangent-mobile-iframe-welcome'),
          c.classList.add('tangent-mobile-iframe-default'))
        : (i.classList.remove('tangent-side-img-width-welcome'),
          i.classList.add('tangent-side-img-width-default'))
    },
    y = () => {
      f(l), c.classList.add('tangent-iframe-summary-style'), w()
    },
    v = (e) => {
      let a = e.contentWindow,
        _ = encodeURIComponent(window.location.href)
      a.postMessage('tangent_client_url:' + _, e.src)
      let d = 'tangent_cookie:' + document.cookie
      a.postMessage(d, e.src)
    },
    L = (e) => {
      let a = e
      s && (a += 10), a !== c.style.height && (c.style.height = `${a}px`)
    },
    H = (e) => {
      try {
        JSON.parse(e)
      } catch {
        return !1
      }
      return !0
    },
    z = () =>
      [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
      ].some((e) => navigator.userAgent.match(e)),
    w = () => {
      let e = c.getBoundingClientRect().top,
        a = e + window.pageYOffset - 145
      window.scrollTo({
        top: a,
        behavior: 'smooth',
      })
    },
    o = (e) => {
      e.classList.remove('tangent-hidden'), e.classList.add('tangent-visible')
    },
    f = (e) => {
      e.classList.remove('tangent-visible'), e.classList.add('tangent-hidden')
    }
  return {
    init: m,
  }
})()
